// extracted by mini-css-extract-plugin
module.exports = {"remarkInfo":"RemarkInfo_remarkInfo__1Q6l1","remarkTextarea":"RemarkInfo_remarkTextarea__1NJeR"};